// src/services/adobeStockAPI.js
const ADOBE_STOCK_ENDPOINT =
  process.env.REACT_APP_ADOBE_STOCK_ENDPOINT ||
  "https://stock.adobe.io/Rest/Media/1/Search/Files";
const MAX_RESULTS_PER_PAGE = 64;

export const searchImages = async (
  apiKey,
  query,
  page = 1,
  orientation = "horizontal"
) => {
  const url = new URL(ADOBE_STOCK_ENDPOINT);
  url.searchParams.append("search_parameters[words]", query);
  url.searchParams.append(
    "search_parameters[limit]",
    MAX_RESULTS_PER_PAGE.toString()
  );
  url.searchParams.append(
    "search_parameters[offset]",
    ((page - 1) * MAX_RESULTS_PER_PAGE).toString()
  );

  // Ensure orientation filter is properly formatted
  url.searchParams.append(
    "search_parameters[filters][orientation]",
    orientation
  );
  // Strict photography filters
  url.searchParams.append("filters[content_type:photo]", "1");
  url.searchParams.append("filters[media_type:photo]", "1");
  url.searchParams.append("filters[illustration]", "0");
  url.searchParams.append("filters[vector]", "0");
  url.searchParams.append("filters[gentech]", "false");

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "X-API-Key": apiKey,
      "X-Product": "PhotoSearchApp/1.0",
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || `API Error: ${response.status}`);
  }

  const data = await response.json();

  // Additional client-side filtering
  if (data.files) {
    data.files = data.files.filter((file) => {
      const title = file.title?.toLowerCase() || "";
      const description = file.description?.toLowerCase() || "";
      const keywords = file.keywords?.join(" ")?.toLowerCase() || "";

      return (
        !title.includes("vector") &&
        !title.includes("illustration") &&
        !title.includes("drawing") &&
        !description.includes("vector") &&
        !description.includes("illustration") &&
        !description.includes("drawing") &&
        !keywords.includes("vector") &&
        !keywords.includes("illustration") &&
        !keywords.includes("drawing") &&
        !title.includes("cartoon") &&
        !title.includes("icon") &&
        !title.includes("silhouette")
      );
    });
  }

  return data;
};
